import React from 'react';
import { PopupWrapper } from '../../resources/styling/appStyle';

const GraphPopup = ({ onClose, open, children }) => {
  return <PopupWrapper>{children}</PopupWrapper>;
};

export default GraphPopup;
